import { isEmpty } from 'lodash'
import React, { useState } from 'react'
import { getCompanySearch } from '../../../../apis/companies/companies'
import Button from '../../../../components/Button'
import Input from '../../../../components/Input'
import Modal, { ModalHeader } from '../../../../components/Modal'
import Guide from '../../../../components/Guide'
import useForm from '../../../../hooks/useForm'
import { postCompaniesBranches } from "../../../../apis/companies/branches"
import { viewLoading } from '../../../../utils/loading'
import systemAlert from '../../../../utils/systemAlert'

const HeadBranch = ({ open, setOpen, type }) => {
  const [companyList, setCompanyList] = useState([]);
  const [selectCompany, setSelectCompany] = useState([]);
  const [isNoResult, setIsNoResult] = useState(false)
  const cancel = () => {
    setOpen(false)
    setIsNoResult(false)
    setCompanyList([])
  }

  const getTitle = () => {
    let title = ""
    switch (type) {
      case 0:
        title = "지점"
        break;
      case 1:
        title = "본점"
        break;
      default:
        break;
    }
    return title
  }

  const submit = (data) => {
    getCompanySearch(data)
      .then((res) => {
        if (isEmpty(res.data.companies)) { setIsNoResult(true) } else { setIsNoResult(false) }
        setCompanyList(res.data.companies);
        setSelectCompany(res.data.companies[0]);
        reset();
      })
      .catch((err) => {
        console.error(err.response);
      });
  };

  const { form, handleOnChange, handleSubmit, reset } = useForm({
    query: "",
  },
    submit,
  );

  const handleRequest = () => {
    //console.log(selectCompany)
    systemAlert(`${selectCompany.name}을(를) ${getTitle()}으로 등록하시겠습니까?`, {

      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '등록',
          onClick: () => {
            viewLoading(true)
            postCompaniesBranches({ companyIdx: selectCompany.idx, type }).then((res) => {
              cancel()
            }).catch(() => { }).finally(() => viewLoading(false))
          }
        }
      ]
    })

  };

  const handleOnChangeCompany = (e) => {
    const { value } = e.target
    setSelectCompany(companyList[value])
  }

  return (
    <Modal size="md" isOpen={open} close={cancel}>
      <div className="head-branch-company-list">
        <ModalHeader>{`${getTitle()} 등록하기`}</ModalHeader>
        {/* <p className="head-branch-label">회사 찾기</p> */}
        <div className="guide-wrap">
          {isNoResult ? (
            <Guide
              color="orange"
              children={<>검색된 회사가 없습니다. 입력한 내용을 다시 확인해주세요</>} />
          ) : (
            <Guide
              children={<>상호명, 대표명, 사업자번호 중 하나를 끝까지 입력해주세요</>} />
          )}
        </div>
        <form onSubmit={handleSubmit}>
          <div className="request-container">
            <div className="reqeust-filter-wrap">
              <Input
                name="query"
                value={form.query}
                placeholder="상호명, 대표명, 사업자번호 중 하나를 입력하세요"
                onChange={handleOnChange}
              />
            </div>
            <div className="request-btn-warp clear">
              <Button
                onClick={handleSubmit}
                className="mt-16 float-right"
              >
                검색
              </Button>
            </div>
          </div>
        </form>
        {!isEmpty(companyList) && (
          <div className="company-list-container">
            <div className="company-list-wrap">
              <select
                className="company-list"
                onChange={handleOnChangeCompany}
              >
                {companyList.map((company, index) => (
                  <option
                    key={index}
                    value={index}
                  >{`${company.name}/${company.comNum}/${company.ceoName}`}</option>
                ))}
              </select>
            </div>
            <button className="company-select-btn" onClick={handleRequest}>
              등록 요청하기
            </button>
          </div>
        )}
      </div>
    </Modal>
  )
}

export default HeadBranch;